import { LOCALES } from "../locales";

export default {
  [LOCALES.CHINESETRADITIONAL]: {
    // general product translation
    January: "january",
    February: "february",
    March: "march",
    April: "april",
    May: "may",
    June: "june",
    July: "july",
    August: "august",
    September: "september",
    October: "october",
    November: "november",
    December: "december",
    class_policy: "Class Policy",
    Faq: "FAQs",
    help: "Help",
    category: "Category",
    frequently_asked_ques: "Frequently Asked Questions",
    customer_support: "Customer Support",
    user_name: "User name",
    password: "Password",
    email_address: "Email address",
    // Header Translations
    notification: "Notification",
    page_loading_aria: "Page is loading",
    state_loading_aria: "State is loading",
    city_loading_aria: "City is loading",
    badge_placeholder: "Badge placeholder",
    badge_overall: "Overall badge",
    badge_demo_skills: "Badge placeholder for demo user, skills",
    badge_demo_be: "Badge placeholder for demo user, business english",
    certificate_placeholder: "Certificate image",
    certificate_download: "Download certificate button",
    prev: "Previous",
    log_out: "Log out",
    //navbar
    navbar_course: "Course",
    navbar_tools: "Tools",
    navbar_skill_index: "Skill Index",
    navbar_level_index: "Level Index",
    navbar_schedule: "Schedule",
    // feature names
    feature_progress: "Progress",
    feature_stressAndIntonation_title: "Stress and intonation",
    feature_soundOfEnglish_title: "Sounds of english",
    feature_vocabularyCenter_title: "Vocabulary center",
    feature_grammarCenter_title: "Grammar center",
    feature_culture_centre_title: "文化中心",
    feature_globalCommunityTutorials_title: "Global community tutorials",
    feature_industryfeed_title: "Industry feed",
    feature_newsfeed_title: "News feed",
    feature_emailTemplates_title: "Email templates",
    feature_talkWithTeacher_title: "Talk with teacher",
    feature_accentsAndDialects_title: "Accents and dialects",
    feature_writingCenter_title: "Writing center",
    feature_toeic_title: "TOEIC",
    feature_toefl_title: "TOEFL",
    // Footer translations
    about: "About",
    legal: "Legal",
    privacy_policy: "Privacy policy",
    Terms_conditions: "Terms of Use",
    //button translations
    button_continue: "繼續",
    button_KnowMore: "Know more",
    button_BuyNow: "Buy Now",
    button_Subscribe: "Subscribe",
    button_GetStarted: "Get started",
    button_GetResult: "Get results",
    button_GetLoading: "Loading...",
    button_view: "View",
    button_GoText: "Go",
    button_Resume: "Continue learning",
    button_ViewDetails: "View Details",
    button_ContinueStudying: "Continue",
    button_next: "下一頁",
    button_confirm: "Confirm",
    // cookie policy
    common_cookiesPolicyText1:
      "By continuing to use this site, you agree to the use of cookies to provide you with better services. Read our",
    common_cookiesPolicyText2: "cookies policy",
    // EO cookie policy
    //login-page-translations//
    login_welcome: "Welcome",
    login_heloo: "Hello again",
    login_welcome_text: "Let's get started.",
    login_log_in: "Log in",
    login_errorIncorrectCreds: "Username or password incorrect",
    login_errorContactAmin: "Your account is not active. Contact your administrator.",
    login_errorSSOuser: "You must log in from your company's learning portal.",
    login_resetPasswordTitle: "Reset Password",
    login_resetConfirmText: "Confirm",
    login_resetSuccess: "We’ve sent you an email containing a link that will allow you to reset your password.",
    login_resetFailure: "Email Address is incorrect",
    // common translations
    message_errorDefault: "Something went wrong",
    message_successUpdated: "Updated successfully",
    message_unknownError: "Unknown error",
    message_unAuthorized: "You are not authorized to access this page",
    message_passwordUpdated: "Password updated successfully",
    message_profileUpdated: "Profile updated successfully",
    message_welcomeSubmitted: "Submitted successfully",
    message_samepasswordError: "Enter a new password, please make sure its not a previously used one.",
    SAR: "選擇一個地區",
    SAL: "選擇一個位置",
    SAT: "選擇一個話題",
    link_readmore: "Read more",
    //--//

    // Idle Timer
    session_expiring: "Session Expiring",
    timer_title_1: "Your session is about to time out.",
    timer_title_2: "To continue studying, click Ok.",
    ok_timer: "Ok",

    profile_title: "個人檔案",
    profile_nameLabel: "我的名字是：",
    profile_countryLabel: "國家/地區",
    profile_stateLabel: "State / Province / Region",
    profile_cityLabel: "城市",
    profile_emailLabel: "Email",
    profile_prefContactLabel: "Preferred contact",
    profile_prefSkypeLabel: "Skype (Personal) ID",
    profile_prefMobileLabel: "Mobile number",
    profile_prefLandlineLabel: "Landline number",
    profile_agreeTerms1: " ",
    profile_agreeTerms2: "I accept and agree to the Terms of Use",
    profile_continueAria: "Continue button",
    profile_TermsAria: "accept terms and conditions",
    profile_stateTooltip: "Your timezone will help us to schedule your online sessions",
    profile_cityTooltip: "If you dont live in one of the cities shown here, please pick the one closest to you",
    profile_emailTooltip: "Verify your email",
    profile_prefTooltip:
      "All your sessions will take place in the virtual classroom, even if you specified a different contact method in the on-boarding process. We ask you about your preferred contact method for internal use only so that we can continually improve your learning experience.",
    profile_fnamePlaceholder: "名字",
    profile_lnamePlaceholder: "姓氏",
    profile_countryPlaceholder: "選擇國家/地區",
    profile_prefContactSelect: "Select your preference",
    profile_statePlaceholder: "Select a state",
    profile_cityPlaceholder: "Select a city",
    profile_emailInvalidMessage: "Email Address is invalid",
    profile_prefContactPlaceholder: "Choose your preference",
    profile_prefSkypePlaceholder: "Skype (Personal)",
    profile_emailVerifiedChip: "Verified",
    profile_emailVerifyChip: "验证",
    profile_emailpopup_head: "Enter verification code",
    profile_emailpopup_resendText: "Resend code",
    profile_emailpopup_resendMessage: "Didn't receive the code?",
    profile_invalidNumber: "Invalid number",
    profile_prefSkypeAria: "Preferred Contact as Skype (Personal) ID",
    profile_prefMobileAria: "Preferred Contact as Mobile",
    profile_prefLandlineAria: "Preferred Contact as Landline",
    profile_emailpopup_incorrectCode: "Invalid code",
    profile_editLabel: "Edit profile",
    profile_editAria: "Edit button",
    profile_mainPasswordPlaceholder: "Enter password here",
    profile_updateLabel: "更新",
    profile_welcomeJumbotron: "歡迎",
    profile_cancelLabel: "取消",
    noAccessl1: "Oops! You don't have permission to view this page!",
    noAccessl2: "Here's a link back to the",
    noAccessl2_1: "homepage",
    noAccessl3: "Please contact your Learnship Administrator for help.",
    profile_license_information: "License information",
    profile_license_message: "您的授權到期日",
    profile_changepass_changepassHead: "變更密碼",
    profile_changepass_currentpassword: "輸入目前密碼",
    profile_changepass_currentpasswordPlaceholder: "Enter current password",
    profile_changepass_newpassword: "New password",
    profile_changepass_newpasswordPlaceholder: "Enter new password",
    profile_changepass_confirmnewpassword: "Confirm new password",
    profile_passMustInclude: "Your password must include:",
    profile_passdontmatch: "Passwords don't match",
    profile_incorrectPassword: "Incorrect current password",
    profile_passwordSubmit_title: "Enter password",
    profile_changepass_conditionLength: "Between 8 to 32 characters",
    profile_changepass_conditionUppercase: "At least one uppercase letter",
    profile_changepass_conditionLowercase: "At least one lowercase letter",
    profile_changepass_conditionSpecialCharacters: "At least one numeric digit and one of these symbols $!#&@?%*_",
    profile_translationLanguage: "翻譯",
    profile_translationLanguagePlaceholder: "Choose a language",
    profile_managerEmailPlaceholder: "Manager email",
    profile_managerEmailpopupPlaceholder: "Manager’s email address",
    // Learner Home Page translations
    learnerhome_survey_header: "We need your feedback!",
    learnerhome_survey_line1: "Your company wants to know about your experience using our service.",
    learnerhome_survey_line2: "Please complete our survey by",
    learnerhome_survey_line3: "Your feedback is very important and greatly appreciated.",
    learnerhome_survey_button1: "Take survey",
    learnerhome_survey_button2: "Skip survey",
    active_course: "Active course",
    admin_header: "Administration",
    admin_dashboard_header: "Dashboard",
    get_startedText: "Click on a course below to get started.",
    product_solo_desc:
      "Learnship SoloTM, our e-learning product, provides everything learners need to practice and improve their business language skills at their own pace.",
    product_conversationPractice_desc:
      "Learners can book one-on-one sessions with trainers to ask questions, discuss a particular issue or role play scenarios. Useful for more experienced learners looking to finesse their skills.",
    product_sprint_businessSkills_desc:
      "This next-generation blended learning program helps learners develop specific business skills—presenting, negotiating, business writing and meeting participation—in record time.",
    product_sprint_levelsProgress_desc:
      "Our next-generation blended language program helps your people rapidly improve their English language skills against a standardized framework.",
    product_sprint_business_german_desc:
      "Our next-generation blended language program helps your people rapidly improve their German language skills against a standardized framework.",
    product_sprint_business_french_desc:
      "Our next-generation blended language program helps your people rapidly improve their French language skills against a standardized framework.",
    product_sprint_business_spanish_desc:
      "Our next-generation blended language program helps your people rapidly improve their Spanish language skills against a standardized framework.",
    product_sprint_business_skills_groups_desc:
      "This next-generation blended learning program helps learners develop specific business skills— in groups—in record time.",
    product_evolve_relocationLanguage_desc:
      "Our employee relocation program helps learners develop a deeper understanding of the language and social nuances of their new country of residence.",
    product_evolve_culturePowerSkills_desc:
      "Give your employees the cross-cultural skills they need to thrive in international working environments and global virtual teams.",
    product_evolve_cultureFocus_desc:
      "Country-specific training and cultural-intelligence for learners who need to gain a better understanding of a specific region and its working culture.",
    product_evolve_cultureChange_desc:
      "This is our premier intercultural business training program for expats. It gives learners an in-depth understanding of what it takes to live and work in a new culture.",
    product_elevate_businessSkills_desc:
      "Short, standardized training modules for language learners who want to improve specific business skills such as presenting, negotiating or team leadership. We also offer specialist courses focused on industry-specific dialects.",
    product_elevate_levelsProgress_desc:
      "This trainer-led business language course helps learners improve their written and verbal skills against a standardized framework.",
    product_coach_languageCoach_desc:
      "Communicate confidently and clearly in boardrooms, emails, negotiations and even around the watercooler. Our one-on-one, hyper-specific executive language coaching helps you master the most important business scenarios. Develop your verbal, written, meeting and personal communication skills.",
    product_coach_cultureCoach_desc:
      "A hyper-focused, one-on-one coaching program for executives looking to solve specific cross-cultural communication problems.",
    product_solo_business_english:
      "A multi-level learning program with engaging online exercises to develop your knowledge and application of Business English at your own pace.",
    product_solo_business_german:
      "A multi-level learning program with engaging online exercises to develop your knowledge and application of Business German at your own pace.",
    product_solo_business_french:
      "A multi-level learning program with engaging online exercises to develop your knowledge and application of Business French at your own pace.",
    product_solo_business_spanish:
      "A multi-level learning program with engaging online exercises to develop your knowledge and application of Business Spanish at your own pace.",
    product_lorem_desc: "Lorem Ipsum lorstatment , consect eturadips cingelioremp.",
    product_dashboard_desc:
      "This is your gateway to Dashboard - an intuitive interface that allows administrators to track usage, analyze learner progress, optimize programs and evaluate ROI.",
    product_reach_desc:
      "Elevate Business English is our online, face-to-face language training for learners who want to improve their overall language proficiency working with a personal trainer.",
    product_lorem_solo_desc:
      "This rich multimedia program helps your people rapidly improve their English language skills against a standardized framework.",
    //feature translations
    feature_cultureCentre_desc:
      "Familiarize yourself with the cultures of the regions that are important to your business and professional life.",
    feature_emailTemplates_desc:
      "Email templates cover a wide variety of business topics. Select the template you want and export it directly to your email client where you can edit it.",
    feature_newsFeed_desc:
      "Welcome to witness a news reading and English learning experience where content and questions are generated live, which gives you access to world news and helps you to enhance your English.",
    feature_talkWithTeacher_desc:
      "This is for learners who want to apply their new skills in conversation. Users can join a virtual group classroom to practice their chosen language and take part in Q&As with speaking speacialists.",
    feature_industryFeed_desc:
      "The Industry Feed combines a library of industry-specific articles with AI-powered language exercises. Choose an article along with a grammar point you want to practice…",
    feature_accentsAndDialects_desc:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut auctor orci at quam porta dictum. Duis id vestibulum dui.",
    feature_accentsAndDialects:
      "Explore the richness of global English usage through our library of regional speech samples.",
    feature_stressAndIntonation_desc:
      "Make your English more natural and easier to understand by learning how to use correct stress, rhythm, and intonation when you speak.",
    feature_soundOfEnglish_desc:
      "Improve your communication skills by learning how to pronounce English sounds correctly.",
    feature_vocabularyCenter_desc:
      "Without grammar, very little can be conveyed. Without vocabulary, nothing can be conveyed. - David Wilkins",
    feature_grammarCenter_desc:
      "The Grammar Center will help you use correct grammar in your speaking and writing. It includes grammar topics, such as basic sentence parts, verbs and verb forms, and sentences and clauses.",
    feature_globalCommunityTutorials_desc:
      "Improve your English language skills with this growing collection of community-developed lessons.",
    feature_toeic_desc:
      "The TOEIC® test is the instrument most widely used by multinational corporations to measure employees’ English proficiency. The TOEIC® uses authentic written materials and dialogue to assess your business English skills.",
    feature_toefl_desc:
      "TOEFL®, the Test of English as a Foreign Language, is used worldwide by colleges and universities, government agencies, and scholarship programs to evaluate English proficiency.",
    feature_businessSituations_desc:
      "The Business Situations Index makes it easy for you to find specific activities so that you can focus on the language you need to communicate in a variety of business situations.",
    //carousel block translations
    title_feature: "Feature",
    we_recommend: "We also recommend",
    // session report translations
    SessionReport_sessionReport: "課程報告",
    SessionReport_sessionDetails: "Details",
    SessionReport_teacherName: "Teacher name",
    SessionReport_sessionReview: "Session review",
    SessionReport_sessionFeedback: "Session feedback",
    SessionReport_sessionMaterials_Assignments: "Session Materials & Assignments",
    SessionReport_instructions: "說明",
    SessionReport_open: "打開",
    SessionReport_invalidSession_Message: "Sorry, there is no report for this session",
    SessionReport_rateSession: "對課程評分",
    SessionReport_handouts: "Handouts",
    SessionReport_coachName: "對課程感覺如何",
    SessionRating_sessionDate: "Session date",
    SessionRating_sessionTime: "Session time",
    SessionRating_sessionDuration: "Session duration",
    SessionRating_status: "Status",
    SessionRating_rateYourExperience: "Rate your experience",
    SessionRating_whatWentWrong: "什麽地方出了錯？",
    SessionRating_content: "內容",
    SessionRating_technology: "技術",
    SessionRating_comment: "發表評論",
    SessionRating_submit: "提交",
    SessionRating_remindMeLater: "稍後提醒我",
    SessionRating_close: "Close",
    SessionRating_completed: "Finished",
    sessionRating_sessionDetails_mins: "Minutes",
    // my schedule page translations
    myschedule_availability_abty_given: "We are working hard to match you with a trainer",
    myschedule_schedule: "My schedule",
    myschedule_availability_needAvl: "We need your availability to schedule your session",
    myschedule_availability_abty_not_given: "Provide / Modify your availability.",
    myschedule_statusCard_completed: "Session(s) completed",
    myschedule_statusCard_remaining: "Session(s) remaining",
    myschedule_statusCard_scheduled: "Session(s) to be scheduled",
    myschedule_statusCard_lost: "Lost (Late cancelled and absent)",
    myschedule_recentUpcoming_courseName: "Course name",
    myschedule_next_session: "Next session",
    myschedule_session_topic: "Session topic",
    myschedule_sessionDetails_communication: "Communication",
    myschedule_no_all_sessions: "No sessions found",
    myschedule_no_upcoming_sessions: "No upcoming sessions found",
    myschedule_no_missed_sessions: "No missed sessions found",
    myschedule_no_completed_sessions: "No completed sessions found",
    myschedule_sessionDetails_allSessions: "All sessions",
    myschedule_sessionDetails_upcomingSessions: "Upcoming sessions",
    myschedule_sessionDetails_completedSessions: "Completed sessions",
    myschedule_sessionDetails_missedSessions: "Missed sessions",
    myschedule_sessionDetails_teacher_name: "Teacher",
    myschedule_sessionDetails_sessions: "Number",
    myschedule_sessionDetails_dateTime: "Date / Time",
    myschedule_sessionDetails_date: "Date",
    myschedule_sessionDetails_time: "Time",
    myschedule_sessionDetails_durationText: "Duration",
    myschedule_sessionDetails_min: "Min",
    myschedule_reschedule_Title: "How to reschedule your session",
    myschedule_reschedule_InstrBegin: "Here's how you can reschedule your sessions with your trainer:",
    myschedule_reschedule_instr1a: "Check session details at the top",
    myschedule_reschedule_instr1b: "The date and time of your session are shown at the top.",
    myschedule_reschedule_instr2: "Trainer’s availability is displayed in green",
    myschedule_reschedule_instr3:
      "You will be able to see your trainer's availability. Available time slots are in green.",
    myschedule_reschedule_instr4: "Select a slot to reschedule",
    myschedule_reschedule_instr5:
      "To reschedule, click into the green area of available time slots for your chosen time.",
    myschedule_reschedule_next_instr1: "No suitable time slot",
    myschedule_reschedule_next_instr2:
      "Try to avoid cancellations, if you really cannot find a suitable time with your trainer, use the 'NO SUITABLE TIME SLOT' button to cancel your session. In this case your trainer will schedule this session for you or an administrator will assist you.",
    myschedule_reschedule_next_instr3: "Change your trainer",
    myschedule_reschedule_next_instr4a:
      "To change your trainer for one or more of your remaining sessions please use our",
    myschedule_reschedule_next_instr4b: "Contact form",
    myschedule_reschedule_next_instr4c:
      " and select {productname} + 'Change Trainer'.Please provide a reason why you would like to change your trainer.",
    myschedule_rechedule_next_info:
      "For further information regarding the rescheduling and cancellation options of trainer please visit our",
    myschedule_rechedule_next_faq: "FAQ portal.",
    myschedule_rechedule_next_noShow: "Don't show this info page again",
    myschedule_rechedule_next_done: "Done",
    myschedule_rechedule_skipButton: "Skip",
    myschedule_upcoming_joinNow: "Join now",
    myschedule_cancel_question: "Are you sure you want to cancel this session?",
    myschedule_cancel_button: "Cancel Session",
    myschedule_cancel_no: "No",
    myschedule_invalid_session: "There are no sessions for this course.",
    myschedule_sessionDuraion_minutes: "Minutes",
    myschedule_homepage_view: "View",
    myschedule_reschedule_button: "Reschedule",
    myschedule_addToCalendar_instr1: "Click on the",
    myschedule_addToCalendar_instr2:
      "download button to get your Learnship schedule. You can then add it to your personal calendar.",
    myschedule_addToCalendar_instr3:
      "If you have previously added a Learnship schedule to your calendar, please make sure to delete the existing one first.",
    myschedule_addToCalendar_instr4: "Learn more about how to add the Learnship schedule to your personal calendar",
    myschedule_addToCalendar_instr5: "here",
    myschedule_no_teacher_title: "Teacher not assigned",
    myschedule_no_teacher_body:
      "No Sessions can be added at the moment (No teachers assigned). Please contact coach@globalenglish.com to continue with your program.",
    myschedule_status_lost: "Lost",
    myschedule_status_finished: "Finished",
    myschedule_status_completed: "Completed",
    myschedule_status_cancelled: "Cancelled",
    myschedule_status_inprogress: "In progress",
    myschedule_status_pending: "Pending",
    myschedule_status_active: "Active",
    myschedule_status_inplanning: "In planning",

    // my schedule page translations end
    // Progress page
    progress_title: "My Progress",
    progress_activity_report: "Activity report",
    progress_test_results: "Test results",
    progress_productname_sprint_skills: "Sprint Business Skills",
    progress_productname_reach_skills: "Reach Skills",
    progress_skill_note:
      "You must complete 70% or more of the coursework and sessions to be eligible for a certificate of completion.",
    progress_overall_card_title_prework: "Pre-work completed",
    progress_overall_card_title_homework: "Homework completed",
    progress_overall_card_title_session: "Session completed",
    progress_overall_card_title_certificate: "Certificate",
    progress_overall_card_title_skillsCompleted: "Skills completed",
    progress_overall_card_title_badgesEarned: "Badges earned",
    progress_overall_card_title_missionsPassed: "Missions passed",
    progress_overall_card_title_timeInReach: "Time in Reach (HH:MM)",
    progress_noSubskill: "There is no subskill to show.",
    progress_activityreport_nodata: "Currently, there is no data to show here. Keep learning and come back later",
    progress_tab_nodata: "No data to show here.",
    progress_tab_notonboarded: "Complete your onboarding to access your reports",
    progress_percentCompleted: "percent completed",
    progress_subskill_preworkTitle: "Pre-Work",
    progress_subskill_homeworkTitle: "Homework",
    progress_subskill_sessionTitle: "Session",
    progress_subskill_sessionStatusCompleted: "Completed",
    progress_subskill_sessionStatusNotCompleted: "Not completed",
    progress_subskill_sessionStatusAbsent: "Absent",
    progress_subskill_sessionStatusUpcoming: "Upcoming",
    progress_subskill_sessionStatusScheduled: "Scheduled",
    progress_subskill_sessionStatusScheduling: "Scheduling",
    progress_subskill_sessionStatusNoSessions: "No sessions",
    progress_subskill_sessionNoDate: "N/A",
    progress_activity_tooltip_totaltime: "Total time",
    progress_activity_tooltip_activitiesCompleted: "Activities completed",
    progress_activity_tooltip_reachMissionsCompleted: "Reach missions completed",
    progress_activity_tooltip_timeinhhmm: "Time in HH:MM",
    progress_activity_tabDaily: "Daily",
    progress_activity_tabWeekly: "Weekly",
    progress_activity_tabMonthly: "Monthly",
    progress_activity_tabQuarterly: "Quarterly",
    progress_activity_tabQuarter: "Quarter",
    progress_activity_tabYearly: "Yearly",
    progress_acitivity_Minutes: "Minutes",
    progress_acitivity_legend_selfpaced: "Self Paced Learning Time",
    progress_acitivity_legend_trainerLed: "Trainer Led Time",
    progress_acitivity_legend_recommended: "Recommended",
    progress_testresults_table_testname: "Test name",
    progress_testresults_table_scores: "Scores",
    progress_testresults_table_date: "Date",
    progress_testresults_placed_text: "Placed",
    progress_test_result_timer_text: "*Your test results will appear in 24 hours.",
    progress_testresults_info: "Your tests results will appear in 24 hours",
    progress_inprogress: "In progress",
    progress_totalscore: "Total score",
    progress_placedText: "Placed",
    progress_button_viewscore: "View detailed report",
    progress_certificate_download_success: "Downloaded successfully",
    progress_partText: "Part",
    progress_emptyPartText: "Other",
    progress_overall_card_title_badge: "Badge",
    progress_total_correctness_percentage: "Your success score is: ",
    progress_badge_dialog_box_title:
      "In order to earn a certificate of completion, we require completion of 70% of the digital exercises.",
    progress_badge_dialog_box_golden: "A success score of 80% earns a gold badge",
    progress_badge_dialog_box_silver: "A success score between 70% and 79% earns a silver badge",
    progress_badge_dialog_box_bronze: "A success score between 50% to 69% earns a bronze badge",
    progerss_badge_dailog_box_digitalActivities:
      "The success score is calculated based on your performance and engagement with the online digital activities",
    progress_badge_dailog_box_liveSessions:
      "The success score is calculated based on your performance and engagement with the online digital activities and live sessions",
    progress_elevate_dialog_box_liveSessions:
      "The success score is calculated based on your performance and engagement with live sessions",

    //EO Progress page
    // Email templates start
    wcTitle: "Writing Center",
    guidelines: "Writing Guidelines",
    sampleDocs: "Sample Documents",
    wcGroup1: "Apologies",
    wcGroup2: "Complaints",
    wcGroup3: "Compliments",
    wcGroup4: "Congratulations",
    wcGroup5: "Documents",
    wcGroup6: "Invitations",
    wcGroup7: "Job Applications",
    wcGroup8: "Marketing and Sales",
    wcGroup9: "Meetings",
    wcGroup10: "Notices",
    wcGroup11: "Orders",
    wcGroup12: "Pricing Information",
    wcGroup13: "Requests",
    wcGroup14: "Thank You",
    wcTitle11: "Apology for a Delay in a Project",
    wcTitle12: "Apology for an Account Error",
    wcTitle13: "Apology for a Late Shipment",
    wcTitle14: "Apology for Delivery of Damaged Goods",
    wcTitle15: "Apology for Missing a Meeting",
    wcTitle21: "General Complaint",
    wcTitle22: "Complaint about a Problem with a Product",
    wcTitle23: "Complaint about an Overcharge to an Account",
    wcTitle31: "Compliment to a Colleague on a Project",
    wcTitle32: "Compliment about Customer Service",
    wcTitle33: "Compliment about a Product",
    wcTitle41: "Congratulations on a Promotion (Formal)",
    wcTitle42: "Congratulations on a Promotion (Informal)",
    wcTitle43: "Congratulations on a Personal Event",
    wcTitle51: "Requested Document",
    wcTitle52: "Order Form or Purchase Order",
    wcTitle53: "Invoice",
    wcTitle61: "Invitation to a Social Event",
    wcTitle62: "Invitation to a Business Event",
    wcTitle63: "Accepting an Invitation",
    wcTitle64: "Declining an Invitation",
    wcTitle65: "Canceling a Business Event",
    wcTitle71: "Acknowledgement of Receipt of Application",
    wcTitle81: "Announcement of a New Product",
    wcTitle82: "Announcement of a New Area Representative",
    wcTitle83: "New Product Demo",
    wcTitle84: "Change of Billing Address",
    wcTitle85: "Follow-Up after a First Sales Meeting",
    wcTitle86: "New Customer Welcome",
    wcTitle87: "Holiday Message to Stockholders or Customers",
    wcTitle91: "Proposing a Time for a Meeting",
    wcTitle92: "Confirming a Meeting",
    wcTitle93: "Postponing a Meeting",
    wcTitle94: "Canceling a Meeting",
    wcTitle95: "Summarizing a Meeting",
    wcTitle101: "Suspended Account",
    wcTitle102: "Request to Close an Account",
    wcTitle111: "Confirming an Order",
    wcTitle112: "Providing Shipping Confirmation",
    wcTitle113: "Canceling an Order",
    wcTitle114: "Changing an Order",
    wcTitle115: "Acknowledging a Delivery",
    wcTitle121: "Providing Pricing Information",
    wcTitle122: "Accepting a Price Quotation",
    wcTitle123: "Rejecting a Price Quotation",
    wcTitle131: "Request for Clarification of Information",
    wcTitle132: "Request for Information about a Product",
    wcTitle133: "Request for Information about a Service",
    wcTitle141: "General Thanks",
    guideGroup1: "Common Writing Problems",
    guideGroup2: "General Business Communication",
    guideGroup3: "Business Documents",
    guideTitle11: "Reasons for Unclear Writing",
    guideTitle12: "Basic Writing Errors",
    guideTitle13: "Problems with Verbs",
    guideTitle21: "Directness in Business Communication",
    guideTitle22: "Language for Sales and Marketing",
    guideTitle23: "Everyday Business Idioms",
    guideTitle31: "Effective Emails",
    guideTitle32: "Presentations: General Tips",
    guideTitle33: "Presentations: Effective Openings",
    backIndex: "Back to Index",
    copyText: "Copy Text",
    exportEmail: "Export Text to Email",
    Blob: "Email templates cover a wide variety of business topics. Select the template you want and export it directly to your email client where you can edit it.",
    OpenInEmail: "Open in email",
    Quote1: "There are currently 3.3 billion email accounts in the world.",
    Quote1By: "Mashable",
    Quote2: "Email generates nearly a 2X return compared to other channels.",
    Quote2By: "Direct Marketing Lead",
    Quote3: "3.5 million emails are sent per second.",
    Quote3By: "Marketing Lead",
    SelectACategory: "Select a category",
    WatchTutorial: "Watch a video tutorial",
    String: "Quote1",
    NoAm: "North America",
    Cenam: "Central America",
    SoAm: "南美洲",
    EUR: "歐洲",
    ASIA: "亞洲",
    CenASIA: "Central Asia",
    SoEASIA: "South East Asia",
    MidEAST: "Middle East",
    AFR: "非洲",
    AUST: "澳洲",
    Cana: "加拿大",
    Mexi: "墨西哥",
    Uniteds: "美國",
    CostaR: "Costa Rica",
    DomRep: "Dominican Republic",
    Guate: "Guatemala",
    Jama: "Jamaica",
    Panam: "Panama",
    TriniTob: "Trinidad & Tobago",
    Arge: "阿根廷",
    Braz: "巴西",
    Chil: "智利",
    Vene: "委內瑞拉",
    Colomb: "Colombia",
    Peru: "Peru",
    Urug: "Uruguay",
    Austria: "Austria",
    Belg: "比利時",
    Bulg: "Bulgaria",
    Croatia: "Croatia",
    Czec: "捷克",
    Denm: "丹麥",
    Finl: "芬蘭",
    Fran: "法國",
    Germ: "德國",
    Greec: "Greece",
    Hung: "匈牙利",
    Icel: "Iceland",
    Irel: "愛爾蘭",
    Ital: "義大利",
    Lith: "Lithuania",
    Luxem: "Luxembourg",
    Neth: "荷蘭",
    Norw: "挪威",
    Pola: "波蘭",
    Port: "Portugal",
    Roma: "羅馬尼亞",
    Russ: "俄羅斯聯邦",
    Serb: "Serbia",
    Slovakia: "Slovakia",
    Slovania: "Slovenia",
    Spai: "西班牙",
    Swed: "瑞典",
    Swit: "瑞士",
    Turk: "土耳其",
    Ukra: "烏克蘭",
    Unitedk: "英國",
    Chin: "中國",
    Hong: "香港",
    Indi: "印度",
    Japa: "日本",
    Mongo: "Mongolia",
    Pakis: "Pakistan",
    SoKore: "South Korea",
    SriLan: "Sri Lanka",
    Taiw: "台灣",
    Afgh: "Afghanistan",
    Azer: "Azerbaijan",
    Kaza: "哈薩克",
    Camb: "Cambodia",
    Indo: "印度尼西亞",
    Malay: "馬來西亞",
    Phil: "菲律賓",
    Sing: "新加坡",
    Thai: "泰國",
    Viet: "Vietnam",
    Bah: "Bahrain",
    Iran: "Iran",
    Iraq: "Iraq",
    Isra: "以色列",
    Jor: "Jordan",
    Kuw: "Kuwait",
    Leb: "Lebanon",
    Oma: "Oman",
    Qat: "Qatar",
    SauArb: "Saudi Arabia",
    UAE: "United Arab Emirates",
    Alger: "Algeria",
    Angol: "Angola",
    Egyp: "埃及",
    Ghana: "Ghana",
    Guin: "Guinea",
    Keny: "Kenya",
    Malaw: "Malawi",
    Moroc: "Morocco",
    Mozam: "Mozambique",
    Nige: "奈及利亞",
    SoAfr: "South Africa",
    Tanz: "Tanzania",
    Ugan: "Uganda",
    Zamb: "Zambia",
    Austra: "澳大利亞",
    NewZea: "New Zealand",
    culturenotes_mainintrotext:
      "Familiarize yourself with the cultures of the regions that are important to your business and professional life.",
    culturenotes_useculturalinfo:
      "Use our cultural information to prepare for important meetings with customers and coworkers around the world.",
    culturenotes_topicfamiliarize:
      "Familiarize yourself with customs, such as business hours, dining out, gift giving, etc. in other cultures.",
    culturenotes_topiclearnculture:
      "Learn about cultural practices, cultural differences, and local manners to avoid making cultural mistakes.",
    culturenotes_tmaworldtext:
      "Country reports are developed by our partner TMA World and are available in downloadable PDF versions.",
    culturenoteslocation_viewbytopic: "View by topic",
    culturenoteslocation_viewbycountry: "View by country",
    culurecenter_disclaimer_title: "免責聲明",
    culturecenter_disclaimer:
      "請將要閱讀的信息視為一般指南，這是您熟悉一種新文化的起點。 該功能將幫助您了解常見的文化模式，使您能更好地理解和解釋人們在行為、態度和反應上的文化差異。 當然您也要知道：特定文化的一般特征因地區和個體而異。",
    culturecenter_intercept_title: "文化中心再次回歸！​​",
    culturecenter_intercept_text1: "經過一段時間的整編，我們很高興地宣布文化中心將重新開放！",
    culturecenter_intercept_text2:
      "通過文化中心，您可以了解全球 20 個國家的行業慣例和習俗。這些國家包括美國、加拿大、墨西哥、中國、日本、印度等...​",
    culturecenter_intercept_direct: "前往文化中心​",
    dailyNewsFeed_resources: "Resources",
    dailyNewsFeed_daily_News: "Daily news feed",
    dailyNewsFeed_newsfeedoftheday: "News feed of the day",
    dailyNewsFeed_feedcontent:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut auctor orci at quam porta dictum. Duis id vestibulum dui. Phasellus interdum augue magna, in tempus velit imperdiet id.",
    dailyNewsFeed_noData: "Sorry, we are unable to fetch your daily news feed, please try again after sometime.",
    dailyNewsFeed_viewMoreCategories: "View more categories",
    // Email templates end
    //Error Page Translations
    error_not_found: "Oops! Page not found.",
    error_contact_csm: "Please contact your Customer Success Manager for help.",
    error_under: "Under",
    error_maintenance: "maintenance",
    error_under_maintenance: "Our site is currently undergoing scheduled maintenance.",
    error_inconvenience: "We're sorry for any inconvenience.",
    error_tryagain: "Please try again later.",
    error_tryagainMins: "Please try again in",
    error_minutes: "minute(s).",
    error_hours: "hour(s)",
    error_oops: "Oops!",
    error_permission_denied: "You don't have permission to view this page!",
    error_link_home: "home page",
    error_contact_admin: "Please contact your Learnship Administrator for help.",
    error_sorry: "We're Sorry.",
    error_load: "There was a problem loading this page.",
    error_clear_cache: "Please clear your browser's cache, check your internet connection, and try again.",
    error_contact: "Please contact our",
    error_contact_cst: "customer support team",
    error_forhelp: "for help.",
    error_having_trouble: "Still having trouble?",
    //Accents and Dialects Dropdowns
    AF: "非洲",
    AS: "亞洲",
    AU: "澳洲 - 大洋洲",
    CA: "加勒比海",
    CE: "中美洲",
    EU: "歐洲",
    MI: "中東",
    NO: "北美洲",
    SO: "南美洲",
    CAMER: "喀麥隆",
    EGYPT: "埃及",
    ETHIO: "衣索比亞",
    GHANA: "迦納",
    GUINE: "幾內亞",
    NIGER: "奈及利亞",
    SOUTH: "南非",
    TANZA: "坦尚尼亞",
    AFGHA: "阿富汗",
    CHINA: "中國",
    INDIA: "印度",
    INDON: "印度尼西亞",
    JAPAN: "日本",
    KAZAK: "哈薩克",
    LEBAN: "黎巴嫩",
    MONGO: "蒙古",
    NORTH: "北越",
    PAKIS: "巴基斯坦",
    PHILI: "菲律賓",
    SINGA: "新加坡",
    KOREA: "韓國",
    SRI_L: "斯里蘭卡",
    TAIWA: "台灣",
    THAIL: "泰國",
    TURKM: "土庫曼",
    AUSTR: "澳大利亞",
    FIJI_: "斐濟",
    NEW_Z: "紐西蘭",
    BERMU: "百慕達",
    CUBA_: "古巴",
    HAITI: "海地",
    COSTA: "哥斯大黎加",
    GUATE: "瓜地馬拉",
    MARTI: "馬丁尼克（法國）",
    TRINI: "千里達及拖巴哥",
    AUSTRI: "奧地利",
    BELAR: "白俄羅斯",
    BELGI: "比利時",
    BULGA: "保加利亞",
    CYPRU: "賽普勒斯",
    CZECH: "捷克",
    DENMA: "丹麥",
    ENGLA: "英格蘭",
    FINLA: "芬蘭",
    FRANC: "法國",
    GEORG: "喬治亞",
    GERMA: "德國",
    GREEC: "希臘 (Hellas)",
    HUNGA: "匈牙利",
    IRELA: "愛爾蘭",
    ITALY: "義大利",
    MACED: "馬其頓",
    NETHE: "荷蘭",
    NORTHI: "北愛爾蘭",
    POLAN: "波蘭",
    ROMAN: "羅馬尼亞",
    RUSSI: "俄羅斯聯邦",
    SCOTL: "蘇格蘭",
    SPAIN: "西班牙",
    SWEDE: "瑞典",
    SWITZ: "瑞士",
    TURKE: "土耳其",
    UKRAI: "烏克蘭",
    WALES: "威爾斯",
    IRAN_: "伊朗",
    IRAQ_: "伊拉克",
    ISRAE: "以色列",
    KUWAI: "科威特",
    SAUDI: "沙烏地阿拉伯",
    SYRIA: "敘利亞",
    CANAD: "加拿大",
    MEXIC: "墨西哥",
    ARGEN: "阿根廷",
    BRAZI: "巴西",
    CHILE: "智利",
    COLOM: "哥倫比亞",
    PARAG: "巴拉圭",
    PERU_: "秘魯",
    VENEZ: "委內瑞拉",
    RPTitle: "Rainbow passage",
    CGACTitle: "Comma Gets a Cure",
    accentsAndDialects_heading: "英語口音與方言",
    US: "美利堅合眾國",
    ALABA: "阿拉巴馬州",
    ALASK: "阿拉斯加州",
    ARKAN: "阿肯色州",
    CALIF: "加利福尼亞州",
    FLORI: "佛羅里達州",
    GEORG_US: "喬治亞州",
    HAWAI: "夏威夷州",
    ILLIN: "伊利諾州",
    INDIA_US: "印地安那州",
    KANSA: "堪薩斯州",
    KENTU: "肯塔基州",
    LOUIS: "路易斯安那州",
    MAINE: "緬因州",
    MARYL: "馬里蘭州",
    MASSA: "麻塞諸塞州",
    MICHI: "密西根州",
    MINNE: "明尼蘇達州",
    MISSI: "密西西比州",
    MISSO: "密蘇里州",
    MONTA: "蒙大拿州",
    NEBRA: "內布拉斯加州",
    NEW_H: "新罕布夏州",
    NEW_J: "紐澤西州",
    NEW_Y: "紐約州",
    NCARO: "北卡羅來那州",
    NDAKO: "北達科他州",
    OHIO_: "俄亥俄州",
    OKLAH: "奧克拉荷馬州",
    PENNS: "賓夕法尼亞州",
    SOUTH_US: "南卡羅來那州",
    TENNE: "田納西州",
    TEXAS: "德克薩斯州",
    VIRGI: "維吉尼亞州",
    WEST_: "西維吉尼亞州",
    WISCO: "威斯康辛州",
    manager_email_managertext:
      "Your company has requested a monthly report for your manager indicating your progress in Learnship. Please provide your manager’s email address below.",
    // survey and notification
    notification_description_plural: "{days} days remaining to complete the survey. You must complete it by {date}.",
    notification_description_singular: "1 day remaining to complete the survey. You must complete it by {date}.",
    notification_maintenance_message: "Halo will be undergoing scheduled maintenance on {date} at {time}.",
    //renewal
    renewal_welcome: "Welcome back to Learnship!",
    renewal_text:
      "Your Learnship license will expire on {date}. To continue improving your Business English Communication skills, renew your license today. Your study plan and all of your work will be saved and you will continue at your current level.",
    renewal_later: "Please ask me later",
    renewal_affirmative: "YES, I want to renew my license.",
    renewal_negative: "NO, I do not want to renew my license.",
    renewal_yes: "YES",
    renewal_no: "NO",
    courselevel: "Course level",
    currentunit: "Current unit",
    upcomingsession: "Upcoming session",
    viewschedule: "View Schedule",
    currentskills: "Skills",
    currentsubskills: "Sub-skills",

    // TWT translations
    twt_talk_with_teacher_title: "Talk with the Teacher",
    twt_sub_heading: "透過線上教室，與教師和其他學習者練習會話技巧！",
    twt_select_sessions: "選擇課堂:",
    twt_view_schedule_title: "查看時間表添加到日曆",
    twt_next_week: "下星期",
    twt_previous_week: "上星期",
    twt_add_to_calendar: "新增至行事曆",
    twt_view_more: "查看更多",
    twt_topic: "話題",
    twt_session_unavailable: "No sessions available",
    twt_level_unassigned: "Sorry you will need a level to view this page, please try after sometime or return to home.",
    twt_joining_session: "Joining",
    twt_select_language: "Select language",
    twt_limit_message: "您在本週已上完一個課程。",
    twt_class_policy: "課程政策",
    twt_class_policy_title: "跟老師交談」 政策與指南",
    twt_class_policy_subHeading:
      "以下的規定和說明對於確保您參加跟老師交談的體驗具有教育性和愉快性是很重要的. 請認真閱讀.",
    twt_class_policy_list01:
      "您每星期可以參加1次跟老師交談*. 課堂最多允許8位學員. 最佳方案: 在課堂開始前到達. 跟老師交談課堂只允許在最初的10分鐘內加入. 例如, 某節課 9:00 開始, 將只允許在 9:10前加入. 最初的10分鐘後您將不能加入課堂. 有無限制取決於您的賬戶類型.",
    twt_class_policy_list02_sub1: "進入課堂時, 輸入您的名字, 國家和級別.",
    twt_class_policy_list02_sub2: `例如, "My name is Leo, and I'm from Sao Paulo, Brazil. I'm in Level 6."`,
    twt_class_policy_list02_sub3: "然後講師將激活您的麥克風，麥克風圖標將出現。",
    twt_class_policy_list03:
      "如果您遇到技術問題, 請點擊Learnship頁面上部的幫助聯系客戶支持提交問題, 您也可以通過GlobalEnglish頁面右下角的<b>Chat</b>工具聯系客戶服務人員. 請不要向老師尋求技術幫助.",
    twt_class_policy_list04:
      "跟老師交談課堂有4個級別: 初級, 中級, 高級和所有級別. 您需要參加適合您級別的課堂. 例如, 如果您的級別是級別0-3, 您需要參加初級課堂. 任何學員 (任何級別) 可以參加所有級別課堂. 如果參加了錯誤級別的課堂, 老師會提示. 您有2個選擇: 您可以告知老師您願意留下不發言,也就是您不能參與 (說話); 或者您離開課堂參加其他時間適合的課堂",
    twt_class_policy_list05:
      "如果您只想聽一堂課, 不想發言, 每星期可以有1次這種機會. 每年只有4次. 如果您使用了這些機會還是想在課堂只聽不參與發言, 您的課堂將會被終止",
    twt_class_policy_list06:
      "我們不會容忍下流和攻擊性的語言. 如果您違反了這個規定, 我們將立刻將您清除課堂. 同時我們會告知您的經理, 並有可能終止您的賬戶",
    twt_class_policy_ok: "Ok",
    twt_max_multi_window_error_message: "您已經通過其他設備進入了這節課, 登出后才可以在當前設備上參加.",
    twt_max_capacity_error_message: "抱歉由於人數已滿您不能參加這節課堂, 請參加其他的課堂.",
    twt_notification_message: "There's a conversation session starting right now. Do you want to join?",

    // sso leaner intercept
    learners_intercept_title: "IMPORTANT NOTICE",
    learners_intercept_text1:
      "The way you log on to Learnship is changing! Citi has partnered with Learnship to enable Single Sign On access for all global learners. As of 9:00am CEST on November 18, 2022, you will be required to go to ",
    learners_intercept_text2: "It is important to note that you will no longer be able to log-on via ",
    learners_intercept_text3: "Please take note of this change and bookmark the new page. ",
    learners_intercept_text4: "For support, please reach out to your local HR contact or ",

    // google learner intercept
    google_intercept_title: "Important Notice",
    google_intercept_subtitle: "The way you log on to Learnship is changing! ",
    google_intercept_text1: "Google has partnered with Learnship to enable ",
    google_intercept_text2: "for all learners. ",
    google_intercept_text3: "Effective from ",
    google_intercept_text4: "you will be required to go to ",
    google_intercept_text5: "It is important to note that, from ",
    google_intercept_text6: ", you will no longer be able to access your Learnship course through ",
    google_intercept_text7:
      "Please make a note of the above change and remember to delete any old bookmarks and replace it with the new link.",
    google_intercept_text8: "For support, please reach out to ",
    google_sso_text: " Single Sign On (SSO) ",
    google_dd_mmm_text: "18th May",
    google_intercept_time: "10:00am CEST",
    google_intercept_date: "18 May 2023",
    google_intercept_on_text: "on",
    google_link_not_work: "This link will not work before that date.",
    learnship_note_google: "Note: ",
    learnship_family_note_google:
      "This change only applies to Googlers. Family members will continue to log in as before.",
    // nestle learner intercept
    nestle_intercept_title: "Important Notice",
    nestle_intercept_subtitle: "The way you log on to Learnship is changing! ",
    nestle_intercept_text1: "Nestlé has partnered with Learnship to enable ",
    nestle_intercept_text2: "for all learners in Switzerland. ",
    nestle_intercept_text3: "Effective from ",
    nestle_intercept_text4: "you will be required to go to ",
    nestle_intercept_text5: "It is important to note that, from ",
    nestle_intercept_text6: ", you will no longer be able to access your Learnship course through ",
    nestle_intercept_text7:
      "Please make a note of the above change and remember to delete any old bookmarks and replace it with the new link.",
    nestle_intercept_text8: "For support, please reach out to your ",
    nestle_service_desk: "Nestlé ServiceDesk",
    nestle_dd_mmm_text: "4th May",
    nestle_sso_text: " Single Sign On (SSO) ",
    nestle_intercept_time: "10:00am CEST",
    nestle_intercept_date: "4th May 2023",
    nestle_intercept_on_text: "on",
    nestle_intercept_or_text: "or ",
    nestle_link_not_work: "This link will not work before that date.",
    learnship_note_nestle: "Note: ",
    learnship_family_note_nestle:
      "This change only applies to Nestlé employees. Family members will continue to log in as before.",
  },
};
